
import * as THREE from 'three';
import { Box3Status, OctreeManager, Node } from './OctreeManager';
import { ThreeView } from '../View3dWebCad';

export class PlaneHit {

    constructor(private plane: THREE.Plane) {
    }

    // 他階の外壁をまとめて取得
    public getTagets(octreeManager: OctreeManager) {

        ThreeView.get().wcItemmgr.addOtherShapes(new THREE.PlaneHelper(this.plane));

        let targets = [];
        const judge = (_status: Node) => {
            if (_status.children.length < 1) {
                for (let j = 0; j < _status.box3Status.length; j++) {
                    if (this.plane.intersectsBox(_status.box3Status[j].box)) {
                        targets.push(_status.box3Status[j]);
                    }
                }
                targets = [...new Set(targets)];
                return;
            }

            for (let i = 0; i < _status.children.length; i++) {
                if (this.plane.intersectsBox(_status.children[i].box)) {
                    judge(_status.children[i]);
                }
            }
        }

        // 無限平面と形状との当たり判定
        const status = octreeManager.nodeStatus;
        if (this.plane.intersectsBox(status.box)) {
            judge(status);
            console.log('無限平面と衝突した形状', targets);
            this.draw(targets);
        } 
    }

    private drawBox: THREE.Box3Helper[] = [];
    
    private getColor(): THREE.Color {
        const color = (Math.random() * 0xFFFFFF | 0).toString(16);
        const randomColor = "#" + ("000000" + color).slice(-6);
        return new THREE.Color(randomColor);
    }
    
    public draw(targets: Box3Status[]) {
        this.remove();
        targets.forEach((status: Box3Status) => {
          const box = new THREE.Box3Helper( status.box, this.getColor() );
          this.drawBox.push( box );
          ThreeView.get().wcItemmgr.addOtherShapes(box);
        });
    }

    public remove() {
        this.drawBox.forEach(box => {
            ThreeView.get().wcItemmgr.removeOtherShapes(box);
        })
    }


}